import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, HostListener, Input, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';

@Directive({
  selector: '[gloZoomOnScroll]',
  standalone: true
})
export class ZoomOnScrollDirective implements AfterViewInit {
  @Input() maxZoom = 1.15;

  private img: HTMLImageElement | null = null;
  
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private host: ElementRef<HTMLElement>) { }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.img = this.host.nativeElement.querySelector('img');
      if (!this.img) return;

      Object.assign(this.img.style, {
        transformOrigin: 'center',
        willChange: 'transform'
      });
      this.update();
    }
  }

  @HostListener('window:scroll')
  onScroll() {
    requestAnimationFrame(() => this.update());
  }

  @HostListener('window:resize')
  onResize() {
    this.update();
  }

  private update() {
    if (!this.img) return;
    // if (!window) return
    const rect = this.host.nativeElement.getBoundingClientRect();

    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

    const progress = 1 - rect.top / window.innerHeight;
    const scale = 1 + (this.maxZoom - 1) * progress;
    this.img.style.transform = `scale(${scale})`;
  }
}